export default __webpack_public_path__ + "static/NotoSans-BoldItalic-a81ad28a2309c7b6860ba80694bf1d9f.ttf";